import { createAsyncThunk } from '@reduxjs/toolkit';
import { ADD_ACTIVEMACHINE } from '@custom/constant';
import { AddMachineArgs } from '@custom/Utils/constants/interfaces';

// Async thunk for adding a new active machine
export const addActiveMachine = createAsyncThunk(
  'machine/addActiveMachine',
  async ({ _id, machineType, totalMachine, machines }: AddMachineArgs, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(ADD_ACTIVEMACHINE, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          _id,
          machineType,
          totalMachine,
          machines,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to add active machine');
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
